var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"diff-check"},[_c('div',{staticClass:"diff-check__label"},[_vm._v("\n    Разделить счёт\n  ")]),_vm._v(" "),_c(_setup.DiffCheckSwitch,{attrs:{"disabled":_setup.diffCheckDisabledCheck},on:{"toggleDiffCheck":_setup.toggleDiffCheck}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }